import { lazy } from "react";
import { Sparkles } from "lucide-react";
import type { AdminModule } from "../types";

const Tasks = lazy(() => import("./pages/Tasks").then((m) => ({ default: m.Tasks })));
const Tools = lazy(() => import("./pages/Tools").then((m) => ({ default: m.Tools })));
const Usage = lazy(() => import("./pages/Usage").then((m) => ({ default: m.Usage })));
const AgentChatConversations = lazy(() =>
  import("./pages/AgentChatConversations").then((m) => ({ default: m.AgentChatConversations })),
);
const AgentChatConversationDetail = lazy(() =>
  import("./pages/AgentChatConversationDetail").then((m) => ({
    default: m.AgentChatConversationDetail,
  })),
);

// norf Manager (Phase 4): versioned task/prompt registry + usage/cost
// dashboard. Backed by the admin ai.* action endpoints (isAdmin-guarded).
// RFC-471 §M2 adds the Conversation Inspector under ai/conversations.
//
// The nav label carries "(AI)" because "norf" alone tells a new support hire
// nothing about what is behind the link.
export const aiModule: AdminModule = {
  key: "ai",
  label: "norf (AI)",
  description: "Task and tool registry, model spend, and the conversation inspector.",
  group: "services",
  icon: Sparkles,
  routes: [
    { path: "tasks", label: "Tasks", element: <Tasks /> },
    { path: "tools", label: "Tools", element: <Tools /> },
    { path: "usage", label: "Usage", element: <Usage /> },
    { path: "conversations", label: "Conversations", element: <AgentChatConversations /> },
    { path: "conversations/:id", element: <AgentChatConversationDetail /> },
  ],
};
